export class AmorgUserRole{

    constructor(
        public id:string,
        public userId:string,
        public roleId:string,
        public title:string,
        public start:Date,
        public end:Date,
        public isCurrentRole:boolean
    ){}
}